import {Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Item} from "../../../../../framework/model/core/items/item";
import {IonInfiniteScroll, IonSearchbar, ModalController} from "@ionic/angular";
import {ModelAddPage} from "../../../../../framework/pages/model-add/model-add.page";
import {Section} from "../../../../../framework/model/core/sections/section";
import {ItemsFilterPage} from "../../pages/items-filter/items-filter.page";
import {Storage} from "@ionic/storage";
import {BusinessService} from "../../../../services/BusinessService";
import {AppDataService} from "../../../../services/AppDataService";
import {Business} from "../../../../../framework/model/core/business/business";
import {AppSettings} from "../../../../conf/appSettings";
import {AppConfig} from "../../../../conf/main";
import {MainService} from "../../../../services/MainService";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";
import {Events} from "../../../../../framework/providers/events";
import {Order} from "../../../../../framework/model/core/order/order";
import {OrderService} from "../../../../services/OrderService";
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";

@Component({
    selector: 'item-list',
    templateUrl: './item-list.component.html',
    styleUrls: ['./item-list.component.scss'],
})
export class ItemListComponent implements OnInit, OnDestroy {

    public initmodels;

    @Input()
    public modelName: string = 'item';

    @Input()
    public filters: object = {};

    @Input()
    public prefix = 'itemList_' + Math.floor(Math.random() * Math.floor(1000000));

    @Input()
    public models: Array<Item> = [];

    @Input()
    public options: object = {};

    public cartOptions: object = {};

    @Input()
    public mode = 'list';

    @Input()
    public view = 'big';

    @Input()
    public listItems: boolean = true;

    @Input()
    public showFilters: boolean = true;

    @Input()
    public showOptions: boolean = true;

    @Input()
    public infiniteScroll: boolean = true;

    @Input()
    public initData: boolean = true;

    @Input()
    public avoidAppData: boolean = false;

    @Input()
    public autoplay: boolean = true;

    @Input()
    public pager: boolean = true;

    @Input()
    public listKey: string;

    private itemsViewPrefix = 'itemsListView';

    public activeFilters: Array<any> = [];

    private firstItemsSets: boolean = false;
    private _listItems: boolean = false;
    private limit: number = 12;
    private offset: number = 0;
    private modelsCount: number;

    public business: Business;

    itemReady = false;
    appuser;
    // public restMode: boolean = false;

    @ViewChild(IonInfiniteScroll, null) ioninfiniteScroll: IonInfiniteScroll;
    @ViewChild(IonSearchbar, null) searchbar: IonSearchbar;

    constructor(public events: Events, public modalController: ModalController, public orderService: OrderService,
                public mainService: MainService, public modelTools: ModelToolsProvider, public modelProvider:ModelProvider,
                public businessService: BusinessService, public appDataService: AppDataService, public appSettings: AppSettings) {

    }

    ngOnInit() {

        this.appuser = this.orderService.getAppUser();

        if (!AppConfig.useAppData)
            this.listItems = true;
        // }
        //
        // ngAfterViewInit() {
        this.filters = JSON.parse(JSON.stringify(this.filters));
        // this.showFilters = false; //
        this._listItems = this.listItems;

        this.options['prefix'] = this.prefix;

        if (this.mode == 'slider')
            this.showOptions = false;

        this.setItemsView();

        if (!this.filters['limit']) this.filters['limit'] = this.limit;
        if (!this.filters['offset']) this.filters['offset'] = this.offset;

        this.business = this.businessService.getBusiness();
        // this.restMode = this.business.data.GlobalSettingsData.bisType == 'rest';
        // if(this.restMode) {

        let settings = this.appSettings.getSettings('items');
        if (this.showOptions)
            this.showOptions = settings['showOptions'] !== null ? settings['showOptions'] : this.showOptions;

        // this.events.subscribe(this.prefix+'_updateItems', (params)=>{
        //     this.getItems();
        // })

        // }
    }

    ionViewDidEnter() {
    }

    ngAfterViewInit() {
        let me = this;
        setTimeout(function () {
            me.itemReady = true;
        }, 500);


        if(this.options['search_auto_focus']) {
            setTimeout(() => {
                me.searchbar.setFocus();
            }, 300);
        }

        // ////console.logthis.limit)
        // ////console.logthis.filters)
        // ////console.log'------')

        // if(this.filters['sectionId'] && this.initData) {
        //     this.initmodels = this.businessService.getAppData(this.filters['sectionId']);
        // }

        if (this.listItems) {
            this.initItems();
        } else {
            this.getAppDataItems()
        }

        this.events.subscribe(this.prefix + '_modelUpdated', (res) => {
            this.addItems(res);
            if (!this.avoidAppData)
                this.appDataService.addItems(res['models']);
        });

        this.events.subscribe(this.prefix + '_updateItemsFilter', (params) => {
            let filters = {}
            for (var k in params) {
                filters[k] = params[k];
            }
            for (var k in this.filters) {
                filters[k] = this.filters[k];
            }
            //console.logparams)
            //console.logthis.filters)

            // if (!this._listItems)
            //     this.listItems = this.activeFilters.length > 0;

            this.getItemsByFilters(filters);
        });


        if (!this.options['slidesPerView'])
            this.options['slidesPerView'] = 2;

        this.options['autoplay'] = this.autoplay;

        if (!this.mainService.sliderAutoPlay) {

            ////console.log'cancel auto play!!!');
            this.options['autoplay'] = false;
        }
    }

    ngOnDestroy()
    {
        console.log("SECTION DESSSTTTT")
        this.events.unsubscribe(this.prefix + '_modelUpdated');
        this.events.unsubscribe(this.prefix + '_updateItemsFilter');
    }


    getItemsByFilters(filters)
    {
        console.log(filters)
        this.modelProvider.custom('getItemsByFilters', filters).then((res) => {
            // console.log(res);
            this.filters['itemsarr'] = res['items']
            this.getItems()
            // this.setFilters(res['res'])
        })
    }

    getItems() {
        // console.log('getItems', this.filters);
        // console.trace()
        if (!this.listItems) {
            this.ioninfiniteScroll.disabled = true;
            this.models.length = 0;
            this.filters['skipped'] = 0;
            this.filters['offset'] = 0;
            this.getAppDataItems()
        } else {
            this.initItems();
            this.events.publish(this.prefix + '_updateFilter', this.filters)
        }
    }


    getAppDataItems() {
        if (this.filters['itemsarr']) {
            let data = this.appDataService.getItems(this.filters['itemsarr'], this.filters);

            this.addItems({
                'models': data['res'],
                'modelsCount': this.filters['itemsarr'].length,
                'skipped': data['skipped']
            });
            ////console.log'length', data['models'].length)
            //console.log'data', data)
        } else if (this.filters['sectionId']) {
            let data = this.appDataService.getSectionItems(this.filters);
            this.addItems(data);
            ////console.log'length', data['models'].length)
            ////console.log'data', data)
        } else if (this.filters['search']) {
            let data = this.appDataService.searchItems(this.listKey, this.filters);
            this.addItems(data);
        }

        else if (this.listKey) {
        //     console.log("LISTEY")
        //     if (this.listKey == 'search' || this.filters['search']) {
        //         this.firstItemsSets = false;
        //         this.options['showLoadAnim'] = true;
        //
        //         let data = this.appDataService.searchItems(this.listKey, this.filters);
        //         let me = this;
        //         // ////console.logdata)
        //
        //         setTimeout(function () {
        //             me.addItems(data);
        //
        //             // me.options['showLoadAnim'] = false;
        //         });
        //     } else {
                let data = this.appDataService.getItemsByKey(this.listKey, this.filters);
                this.addItems(data);
        //     }
        }

        // this.firstItemsSets = true;

        // console.log('modelsCount', this.modelsCount)
        // console.log('length', this.models.length)
        // ////console.logthis.ioninfiniteScroll)

        if (this.ioninfiniteScroll) {
            this.ioninfiniteScroll.disabled = this.modelsCount == this.models.length;
        }
    }

    initItems() {
        this.models = [];
        this.filters['limit'] = this.limit;
        this.filters['offset'] = this.offset;
        this.filters['ordering'] = !this.filters['ordering'] ? '-issale' : this.filters['ordering'];
        this.firstItemsSets = false;
        // this.ioninfiniteScroll.disabled = false;

    }

    addItems(res) {
        let models = res['models'];
        this.modelsCount = res['modelsCount'];


        for (var k in res['models']) {
            this.models.push(models[k]);
        }

        // let me = this;
        // setTimeout(function () {
        this.firstItemsSets = true;
        // }, 1200)

        // console.log("ADD ITEMS", res, this.modelsCount, this.models.length)


        // console.log('modelsCount', this.modelsCount)
        // console.log('length', this.models.length)

        // if (this.modelsCount == this.models.length)
        if (this.ioninfiniteScroll) {
            this.ioninfiniteScroll.disabled = this.modelsCount == this.models.length;
        }
        // //console.logthis.models)
        // //console.logthis.filters)
    }

    nextPage(e) {
        // //console.log'NEXT PAGE!')
        if (this.options['showLoadAnim']) {
            this.stopInfinite(e);
            return;
        }

        // ////console.log"NEXT PAGE!")

        this.filters['offset'] += this.limit;


        if (this.listItems) {
            this.events.publish(this.prefix + '_updateFilter', this.filters);
        } else {
            let data;
            if (this.filters['itemsarr']) {
                console.log(this.filters)
                let itemsres = this.appDataService.getItems(this.filters['itemsarr'], this.filters);
                data = {
                    'models': itemsres['res'],
                    'modelsCount': this.filters['itemsarr'].length,
                    'skipped': itemsres['skipped']
                }
            } else if (this.filters['sectionId'])
                data = this.appDataService.getSectionItems(this.filters);
            else
                data = this.appDataService.getItemsByKey(this.listKey, this.filters);

            this.addItems(data);
        }
        this.stopInfinite(e)
    }

    stopInfinite(e) {
        if (!e) return;
        // this.ioninfiniteScroll.disabled = true;

        // let me = this;
        setTimeout(function () {
            e.target.complete();
            // me.ioninfiniteScroll.disabled = !me.ioninfiniteScroll.disabled;
        }, 200)
    }


    setItemsView() {
        // this.modelTools.getKey('agentToolActive').then((res) => {
        //     this.cartOptions['agentTechnicalTool'] = this.orderService.isAgentTool() && this.orderService.getCartOptionKey('agentTechnicalTool');
        // });
        this.cartOptions = this.orderService.getCartOptions();


        if (!this.options['itemsView']) {
            // if (this.view)
            //     this.options['itemsView'] = this.view;
            // else {
                this.modelTools.getKey(this.itemsViewPrefix).then((res) => {
                    if (!this.showOptions) {
                        this.options['itemsView'] = 'big';
                        this.changeView(this.options['itemsView']);
                        return;
                    }

                    if (!res) {
                        res = this.business.data.GlobalSettingsData.itemsView;
                    }

                    if (!res)
                        res = 'big';

                    this.options['itemsView'] = res;
                    this.changeView(this.options['itemsView']);

                    return;
                });

                return
            // }
        }

        this.options['itemsView'] = this.view;
        this.changeView(this.options['itemsView']);

    }

    changeView(key, saveOnData = false) {

        let settings = this.appSettings.getSettings('items');
        // this.options['agentTechnicalTool'] = this.orderService.isAgentTool();


        //console.logkey)

        // key = 'big'

        this.options['itemsView'] = key;
        this.view = this.options['itemsView'];
        // this.options['slidesPerView'] = 2;


        this.options['view_class'] = settings['view'] ? settings['view'] : '';
        // console.log(this.options);

        // if (settings['view'])
        //     this.view = this.options['itemsView'];
        // else
        //     this.view = this.options['itemsView'];
        //
        // if (key == 'small' && settings['small_view_str']) {
        //     this.view += settings['small_view_str'];
        // }

        ////console.log'viewview', this.view)

        if (saveOnData)
            this.saveOnStorage(this.itemsViewPrefix, key)
    }

    changeAgentToolVisible() {
        this.orderService.changeAgentToolVisible();
        this.cartOptions = this.orderService.getCartOptions();

        // this.options['agentTechnicalTool'] = !this.options['agentTechnicalTool'];
        // this.saveOnStorage('agentToolActive', this.options['agentTechnicalTool']);
    }

    saveOnStorage(key, value) {
        this.modelTools.setKey(key, value);
    }

    search()
    {
                console.log(this.filters)

        delete this.filters['itemsarr']
        console.log(this.filters)
        this.getItems();
        console.log(this.models)
    }

}
